export default "__VITE_ASSET__D0sNB4MJ__"